<!-- use tags -->

import Layout1 from "../../src/routes/+layout.marko";
import Layout2 from "../../src/routes/tools/persona/+layout.marko";
import Page from "../../src/routes/tools/persona/$game/view/+page.marko";

<Layout1>
	<Layout2>
		<Page/>
	</>
</>
